import { Configuration, LogLevel } from "@azure/msal-browser";

const tenantName = process.env.REACT_APP_B2C_TENANT || "";
const userFlow = process.env.REACT_APP_B2C_USER_FLOW || "";

// MSAL Configuration object
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_B2C_CLIENT_ID || "",
        authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/${userFlow}`,
        // Always use the current origin as redirect target so builds
        // work across environments (localhost, dev, prod) without
        // hardcoding environment variables.
        redirectUri: (typeof window !== "undefined" ? window.location.origin : undefined),
        postLogoutRedirectUri: (typeof window !== "undefined" ? window.location.origin : undefined),
        knownAuthorities: [`${tenantName}.b2clogin.com`],
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

// Scopes for user consent during sign-in
// Base OIDC scopes used for sign-in only
export const loginRequest = {
    scopes: ["openid", "profile", "offline_access"],
};

// API scopes used when acquiring tokens to call the backend
// Configure via REACT_APP_API_SCOPE (space-separated if multiple)
export const apiScopes: string[] = (process.env.REACT_APP_API_SCOPE
    ? process.env.REACT_APP_API_SCOPE.split(" ")
    : [`https://karimbab2c.onmicrosoft.com/${process.env.REACT_APP_BACKEND_CLIENT_ID}/access_as_user`]);
